'use strict';

import type { IndAppAlternateId } from '../../Entities/Ind/IndAppAlternateId';
import { EntityCollection } from '../EntityCollection';

export class IndAppAlternateIdCollection extends EntityCollection<IndAppAlternateId> {}
